import { Stack } from "@mui/material";
import TextInput from "../Inputs/TextInput";
import { useTranslation } from "react-i18next";
import LabelTitle from "../Displays/LabelTitle";
import { UseFormReturn } from "react-hook-form";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { Energy, MinusCircle, Persons, PlusCircle } from "src/assets";
import { SESSION_KEYS, SITE_TECHNICAL_DATA } from "src/consts/session";
import { AnnualGridSupplyFormValues } from "src/pages/AnnualGridSupply";
import { calculateYearlyGridSupply } from "src/helpers/calculateYearlyGridSupply";

interface AnnualGridSupplyFormProps {
  form: UseFormReturn<AnnualGridSupplyFormValues, any, undefined>;
}

const AnnualGridSupplyForm = ({ form }: AnnualGridSupplyFormProps) => {
  const { t } = useTranslation();

  const [getSiteTechnicalData] = useSessionStorage<SITE_TECHNICAL_DATA>(
    SESSION_KEYS.SITE_TECHNICAL_DATA
  );

  const calculatePowerConsumption = (
    personsInHousehold: number,
    form: UseFormReturn<AnnualGridSupplyFormValues, any, undefined>
  ) => {
    const siteTechnicalData = getSiteTechnicalData();
    const updatedYearlyGridSupply = calculateYearlyGridSupply(
      personsInHousehold,
      siteTechnicalData
    );
    form.setValue("yearlyGridSupplyKwh", updatedYearlyGridSupply);
    form.trigger("yearlyGridSupplyKwh");
  };

  const handleIncrement = (
    form: UseFormReturn<AnnualGridSupplyFormValues, any, undefined>
  ) => {
    const personsInHousehold = form.getValues("personsInHousehold");

    if (personsInHousehold === 5) return;
    const updatedPersonsInHousehold = personsInHousehold + 1;
    form.setValue("personsInHousehold", updatedPersonsInHousehold);
    calculatePowerConsumption(updatedPersonsInHousehold, form);
  };

  const handleDecrement = (
    form: UseFormReturn<AnnualGridSupplyFormValues, any, undefined>
  ) => {
    const personsInHousehold = form.getValues("personsInHousehold");

    if (personsInHousehold === 1) return;
    const updatedPersonsInHousehold = personsInHousehold - 1;

    form.setValue("personsInHousehold", updatedPersonsInHousehold);
    calculatePowerConsumption(updatedPersonsInHousehold, form);
  };

  return (
    <Stack gap={2}>
      <TextInput
        fullWidth
        InputProps={{
          readOnly: true,
          startAdornment: <Persons />,
          endAdornment: (
            <Stack direction="row" gap={2} alignItems="center">
              <Stack
                direction="row"
                sx={{
                  cursor: "pointer",
                }}
                onClick={() => handleDecrement(form)}
              >
                <MinusCircle />
              </Stack>
              <Stack
                direction="row"
                sx={{
                  cursor: "pointer",
                }}
                onClick={() => handleIncrement(form)}
              >
                <PlusCircle />
              </Stack>
            </Stack>
          ),
        }}
        control={form.control}
        name="personsInHousehold"
        labelText={t("page.annualGridSupply.personsInHouseholdLable")}
      />

      <TextInput
        fullWidth
        placeholder={t("page.annualGridSupply.annualConsumptionLable")}
        InputProps={{
          startAdornment: <Energy />,
          endAdornment: (
            <LabelTitle
              sx={{
                whiteSpace: "nowrap",
              }}
              fontWeight={600}
              text={t("page.annualGridSupply.annualConsumptionUnitOfMeasure")}
            />
          ),
        }}
        control={form.control}
        name="yearlyGridSupplyKwh"
        labelText={t("page.annualGridSupply.annualConsumptionLable")}
      />
    </Stack>
  );
};

export default AnnualGridSupplyForm;
